export class Product {
  public name: string;
  public quantity: number;
  public cost: number;

  constructor(name: string, quantity: number, cost: number) {
    this.name = name;
    this.quantity = quantity;
    this.cost = cost;
  }
  getName(): string {
    return this.name;
  }
  getQuantity(): number {
    return this.quantity;
  }
  incQuantity(): void {
    this.quantity++;
  }
  decQuantity(): void {
    this.quantity--;
  }
  getCost(): number {
    return this.cost;
  }
}
